import { render } from "./LanguageView.vue?vue&type=template&id=062bd1d1"
import script from "./LanguageView.vue?vue&type=script&lang=js"
export * from "./LanguageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__